import "../../styles/reuse/reuseDisplay.css";

export { ReuseDisplay };
type Props = {
  extractedData: {
    // get index of current extracted
    getIndex: () => number;
    // get other reuse options
    getReuse: () => Array<any>;
  };
};

function ReuseDisplay(props: Props) {
  if (props.extractedData.getReuse().length) {
    console.log(props.extractedData.getReuse());
  }
  return (
    <span className={`reuseDisplay`}>
      {`${props.extractedData.getIndex() + 1} / ${props.extractedData.getReuse().length}`}
    </span>
  );
}
